var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgMobilepay(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    x: "0px",
    y: "0px",
    viewBox: "0 0 215 69",
    style: {
      enableBackground: "new 0 0 215 69"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#5A78FF"
    },
    d: "M26,69c-2.4,0-4.5-1.4-5.4-3.6L0.4,16.8c-1.2-3,0.2-6.4,3.2-7.6l21.1-8.7c1.4-0.6,3-0.6,4.5,0 c1.4,0.6,2.6,1.7,3.2,3.2l20.1,48.6c1.2,3-0.2,6.4-3.2,7.6l-21.1,8.7C27.5,68.8,26.7,69,26,69z M26.9,3.1c-0.4,0-0.7,0.1-1,0.2 L4.8,12.1c-0.7,0.3-1.2,0.8-1.5,1.5s-0.3,1.4,0,2.1l20.1,48.6c0.6,1.4,2.1,2,3.5,1.5l21.1-8.7l0,0c0.7-0.3,1.2-0.8,1.5-1.5 c0.3-0.7,0.3-1.4,0-2.1L29.4,4.8C29,3.8,28,3.1,26.9,3.1z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "mobilepay_SVG_ID_1_",
    gradientUnits: "userSpaceOnUse",
    x1: -447.7435,
    y1: 392.1894,
    x2: -447.7069,
    y2: 392.9553,
    gradientTransform: "matrix(2.8982 -1.2005 -7.969 -19.2389 4461.2056 7029.8149)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#504678"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.302,
    style: {
      stopColor: "#504678",
      stopOpacity: 0.616
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.608,
    style: {
      stopColor: "#504678",
      stopOpacity: 0.283
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.852,
    style: {
      stopColor: "#504678",
      stopOpacity: 0.076
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#504678",
      stopOpacity: 0
    }
  })), /*#__PURE__*/React.createElement("polygon", {
    style: {
      opacity: 0.7,
      fill: "url(#mobilepay_SVG_ID_1_)",
      enableBackground: "new"
    },
    points: "30.7,8 33.6,6.8 41.6,26 38.7,27.2  "
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "mobilepay_SVGID_2_",
    gradientUnits: "userSpaceOnUse",
    x1: -701.2814,
    y1: 441.2536,
    x2: -701.2448,
    y2: 442.0194,
    gradientTransform: "matrix(-2.8982 1.2005 9.0206 21.7777 -5970.0269 -8734.6182)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#504678"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.302,
    style: {
      stopColor: "#504678",
      stopOpacity: 0.616
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.608,
    style: {
      stopColor: "#504678",
      stopOpacity: 0.283
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.852,
    style: {
      stopColor: "#504678",
      stopOpacity: 0.076
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#504678",
      stopOpacity: 0
    }
  })), /*#__PURE__*/React.createElement("polygon", {
    style: {
      opacity: 0.7,
      fill: "url(#mobilepay_SVGID_2_)",
      enableBackground: "new"
    },
    points: "51.1,49 48.2,50.2 39.2,28.4 42.1,27.2  "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#5A78FF"
    },
    d: "M44.5,35.7c-6,2.5-11.1,5.9-14.4,10.1l-8.5-20.5c3.9-4.5,8.8-8,14.4-10.1c6-2.5,12.1-3.7,17.3-3l8.5,20.5 C55.9,32.3,50,33.3,44.5,35.7z"
  }), /*#__PURE__*/React.createElement("g", {
    transform: "translate(21 11)",
    style: {
      opacity: 0.4
    }
  }, /*#__PURE__*/React.createElement("linearGradient", {
    id: "mobilepay_SVGID_3_",
    gradientUnits: "userSpaceOnUse",
    x1: -581.5435,
    y1: 397.0202,
    x2: -581.1066,
    y2: 397.271,
    gradientTransform: "matrix(40.154 0 0 -33.8277 23357.4492 13453.7158)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#504678"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.179,
    style: {
      stopColor: "#504678",
      stopOpacity: 0.872
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.526,
    style: {
      stopColor: "#504678",
      stopOpacity: 0.536
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#504678",
      stopOpacity: 0
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.9,
      fill: "url(#mobilepay_SVGID_3_)",
      enableBackground: "new"
    },
    d: "M23.5,24.7c-6,2.5-11.1,5.9-14.4,10.1L0.7,14.3C4.5,9.8,9.5,6.3,15,4.2c6-2.5,12.1-3.7,17.3-3l8.5,20.5 C34.9,21.3,29,22.3,23.5,24.7z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "mobilepay_SVGID_4_",
    gradientUnits: "userSpaceOnUse",
    x1: -581.2029,
    y1: 397.3333,
    x2: -581.2275,
    y2: 397.4993,
    gradientTransform: "matrix(40.154 0 0 -33.8277 23357.4492 13453.7158)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#504678"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.643,
    style: {
      stopColor: "#504678",
      stopOpacity: 0.332
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#504678",
      stopOpacity: 0
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.7,
      fill: "url(#mobilepay_SVGID_4_)",
      enableBackground: "new"
    },
    d: "M23.5,24.7c-6,2.5-11.1,5.9-14.4,10.1L0.7,14.3C4.5,9.8,9.5,6.3,15,4.2c6-2.5,12.1-3.7,17.3-3l8.5,20.5 C34.9,21.3,29,22.3,23.5,24.7z"
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#5A78FF"
    },
    d: "M47.3,42c-6.5,0-12.5,1.3-17.1,3.8V25.1c5.3-2.7,11.2-4,17.1-3.8c6.5,0,12.6,1.2,17.1,3.8v20.8 C59.1,43.1,53.2,41.8,47.3,42z M80.6,42l5.3-16.7c0.1-0.2,0.3-0.4,0.5-0.4h2.7c0.2,0,0.4,0.2,0.5,0.4l4.1,10.5 c0.1,0.2,0.3,0.2,0.4,0l4.1-10.5c0.1-0.2,0.3-0.4,0.5-0.4h2.7c0.2,0,0.4,0.2,0.5,0.4L107,42c0.1,0.1,0,0.3,0,0.4 c-0.1,0.1-0.2,0.2-0.4,0.2h-3.2c-0.2,0-0.4-0.1-0.5-0.4l-3.3-10.8c-0.1-0.2-0.3-0.2-0.4,0l-4,10.8c-0.1,0.3-0.3,0.4-0.6,0.4h-1.8 c-0.3,0-0.4-0.2-0.6-0.4l-4.1-10.8c-0.1-0.2-0.3-0.2-0.3,0l-3.4,10.8c-0.1,0.2-0.3,0.4-0.5,0.4h-3c-0.1,0-0.3-0.1-0.3-0.2 S80.6,42.1,80.6,42z M108,36c-0.1-2.8,1.6-5.4,4.2-6.6s5.6-0.6,7.7,1.4c2,2,2.7,5,1.6,7.6c-1.1,2.6-3.6,4.4-6.5,4.4 c-1.9,0.1-3.6-0.6-5-1.9C108.7,39.6,108,37.9,108,36z M118.4,36c-0.1-1.9-1.7-3.3-3.6-3.2s-3.3,1.7-3.3,3.5s1.6,3.4,3.5,3.3 C116.9,39.6,118.5,37.9,118.4,36L118.4,36z M128.2,41.5c-0.3-0.2-0.5-0.1-0.5,0.2v0.3c0,0.3-0.2,0.5-0.5,0.5h-2.4 c-0.3,0-0.5-0.2-0.5-0.5V25.4c0-0.3,0.2-0.5,0.5-0.5h2.6c0.3,0,0.5,0.2,0.5,0.5v4.8c0,0.3,0.2,0.4,0.6,0.2c1-0.7,2.2-1.1,3.4-1.1 c3.6,0,6.3,3,6.3,6.9c0.1,1.8-0.6,3.5-1.8,4.8s-2.9,2-4.6,2.1C130.4,42.9,129.1,42.4,128.2,41.5z M134.6,36 c0.1-1.3-0.5-2.5-1.6-3.2s-2.5-0.7-3.6,0s-1.7,1.9-1.6,3.2c0,0.9,0.3,1.8,0.9,2.5c0.6,0.7,1.5,1.1,2.5,1.1c0.9,0,1.8-0.4,2.5-1.1 C134.2,37.9,134.6,36.9,134.6,36L134.6,36z M140.2,26.1c0-1.1,0.9-2,2-2s2,0.9,2,2c0,1.1-0.9,2-2,2S140.2,27.2,140.2,26.1z  M140.4,42.1V30c0-0.3,0.2-0.5,0.5-0.5h2.6c0.1,0,0.3,0,0.4,0.1c0.1,0.1,0.2,0.2,0.2,0.4v12.1c0,0.3-0.2,0.5-0.5,0.5h-2.6 C140.6,42.5,140.4,42.3,140.4,42.1L140.4,42.1z M146.9,38.1V25.4c0-0.3,0.2-0.5,0.5-0.5h2.6c0.3,0,0.5,0.2,0.5,0.5v12.9 c0,0.8,0.4,1.4,1.3,1.4c0.1,0,0.3,0.1,0.3,0.1s0.1,0.2,0.1,0.3v2.1c0,0.3-0.2,0.5-0.5,0.5C148.2,42.7,146.9,41.6,146.9,38.1z  M153.1,36.1c0-2.4,1.3-4.6,3.4-5.8c2.1-1.2,4.7-1.2,6.8,0c2.1,1.2,3.4,3.5,3.4,5.9c0,0.5-0.1,0.9-0.6,0.9h-8.9 c-0.2,0-0.3,0.1-0.3,0.3c0.2,1.6,1.6,2.7,3.2,2.6c0.9,0,1.9-0.4,2.5-1.1c0.2-0.3,0.5-0.4,0.8-0.4h2.4c0.4,0,0.6,0.3,0.4,0.7 c-1.4,2.9-4.6,4.4-7.7,3.7C155.3,42,153.1,39.2,153.1,36.1L153.1,36.1z M162.6,34.9c0.2,0,0.3-0.1,0.2-0.3c-0.3-1.4-1.5-2.5-3-2.4 c-1.4,0-2.7,1-3,2.4c-0.1,0.2,0,0.4,0.2,0.4H162.6z M168.8,42.1V25.4c0-0.3,0.2-0.5,0.5-0.5h8.2c3.7,0,6.3,2.2,6.3,5.9 s-2.9,5.9-6.5,5.9h-4.3c-0.1,0-0.3,0-0.4,0.1c-0.1,0.1-0.1,0.2-0.1,0.4v4.9c0,0.3-0.2,0.5-0.5,0.5h-2.7 C169,42.5,168.8,42.3,168.8,42.1z M177.3,33.6c1.5,0,2.8-1.3,2.7-2.9c0-0.7-0.3-1.4-0.8-2c-0.5-0.5-1.2-0.8-2-0.8h-4.4 c-0.3,0-0.4,0.2-0.4,0.5v4.7c0,0.3,0.1,0.5,0.4,0.5L177.3,33.6z M185,36c-0.1-1.8,0.6-3.5,1.8-4.8c1.2-1.3,2.9-2,4.7-2.1 c1.3,0,2.5,0.5,3.5,1.3c0.2,0.2,0.5,0.2,0.5-0.1V30c0-0.3,0.2-0.5,0.5-0.5h2.4c0.3,0,0.5,0.2,0.5,0.5v8.6c0,0.7,0.2,0.9,0.7,1 c0.2,0,0.4,0.2,0.4,0.4v2.3c0,0.2-0.2,0.4-0.4,0.4c-1.7,0-2.7-0.5-3.3-1.5c-0.2-0.3-0.3-0.3-0.6-0.1c-1.1,1.1-2.6,1.8-4.2,1.7 c-1.8-0.1-3.5-0.8-4.7-2.1C185.5,39.5,184.9,37.8,185,36L185,36z M195.4,36c0.1-1.3-0.5-2.5-1.6-3.2c-1.1-0.7-2.5-0.7-3.6,0 c-1.1,0.7-1.7,1.9-1.6,3.2c-0.1,1.3,0.5,2.5,1.6,3.2c1.1,0.7,2.5,0.7,3.6,0C194.9,38.5,195.5,37.3,195.4,36z M201.1,47.1V45 c0-0.3,0.2-0.5,0.5-0.5c1.7,0.1,3.2-0.9,3.7-2.5c0.1-0.3,0.1-0.7-0.1-1l-4.8-10.8c-0.1-0.1-0.1-0.3,0-0.5c0.1-0.1,0.2-0.2,0.4-0.2 h2.6c0.3,0,0.4,0.2,0.5,0.5l3,6.9c0.2,0.5,0.5,0.5,0.8,0l2.9-6.9c0.1-0.3,0.2-0.4,0.5-0.4h2.5c0.2,0,0.3,0.1,0.4,0.2 c0.1,0.1,0.1,0.3,0,0.4l-4.9,11.6c-1.8,4.2-3.7,5.8-7.5,5.8C201.4,47.6,201.1,47.4,201.1,47.1z"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgMobilepay);
export default __webpack_public_path__ + "static/media/mobilepay.15205ca102805d008677f4501b87d6f8.svg";
export { ForwardRef as ReactComponent };